export const STATE_REGISTRY = {
    AL: { name: 'Alabama', fee: 236 },
    AK: { name: 'Alaska', fee: 250 },
    AZ: { name: 'Arizona', fee: 85 },
    AR: { name: 'Arkansas', fee: 45 },
    CA: { name: 'California', fee: 70 },
    CO: { name: 'Colorado', fee: 50 },
    CT: { name: 'Connecticut', fee: 170 },
    DE: { name: 'Delaware', fee: 90 },
    FL: { name: 'Florida', fee: 125 },
    GA: { name: 'Georgia', fee: 100 },
    HI: { name: 'Hawaii', fee: 76 },
    ID: { name: 'Idaho', fee: 144.5 },
    IL: { name: 'Illinois', fee: 256 },
    IN: { name: 'Indiana', fee: 95 },
    IA: { name: 'Iowa', fee: 50 },
    KS: { name: 'Kansas', fee: 160 },
    KY: { name: 'Kentucky', fee: 40 },
    LA: { name: 'Louisiana', fee: 130 },
    ME: { name: 'Maine', fee: 228 },
    MD: { name: 'Maryland', fee: 150 },
    MA: { name: 'Massachusetts', fee: 520 },
    MI: { name: 'Michigan', fee: 50 },
    MN: { name: 'Minnesota', fee: 155 },
    MS: { name: 'Mississippi', fee: 53 },
    MO: { name: 'Missouri', fee: 50 },
    MT: { name: 'Montana', fee: 90 },
    NE: { name: 'Nebraska', fee: 108 },
    NV: { name: 'Nevada', fee: 425 },
    NH: { name: 'New Hampshire', fee: 102 },
    NJ: { name: 'New Jersey', fee: 129 },
    NM: { name: 'New Mexico', fee: 52 },
    NY: { name: 'New York', fee: 200 },
    NC: { name: 'North Carolina', fee: 228 },
    ND: { name: 'North Dakota', fee: 135 },
    OH: { name: 'Ohio', fee: 99 },
    OK: { name: 'Oklahoma', fee: 104 },
    OR: { name: 'Oregon', fee: 100 },
    PA: { name: 'Pennsylvania', fee: 250 },
    RI: { name: 'Rhode Island', fee: 156 },
    SC: { name: 'South Carolina', fee: 125 },
    SD: { name: 'South Dakota', fee: 154 },
    TN: { name: 'Tennessee', fee: 325 },
    TX: { name: 'Texas', fee: 300 },
    UT: { name: 'Utah', fee: 134 },
    VT: { name: 'Vermont', fee: 155 },
    VA: { name: 'Virginia', fee: 100 },
    WA: { name: 'Washington', fee: 200 },
    DC: { name: 'Washington D.C.', fee: 149 },
    WV: { name: 'West Virginia', fee: 155 },
    WI: { name: 'Wisconsin', fee: 131 },
    WY: { name: 'Wyoming', fee: 103 },
    PR: { name: 'Puerto Rico', fee: 250 },
};

const STATE_CODES = Object.keys(STATE_REGISTRY);

const STATE_NAMES = STATE_CODES.map((code) => STATE_REGISTRY[code]?.name).filter(Boolean);

const STATE_BY_NAME = STATE_CODES.reduce((acc, code) => {
    const state = STATE_REGISTRY[code];
    acc[state.name] = { ...state, code };
    return acc;
}, {});

export const STATE_OPTIONS = STATE_CODES.map((code) => ({
    value: code,
    label: STATE_REGISTRY[code].name,
}));

export const STATE_OPTIONS_BY_NAME = STATE_NAMES.map((state) => ({
    value: state,
    label: state,
}));

export const STATE_DOB_REQUIREMENTS = {
    UT: "Utah requires the LLC organizer's date of birth on formation documents.",
};

// Cart-configured overrides, populated from the synced cart record on hydration.
// When set, these take precedence over the hardcoded STATE_REGISTRY / $199 defaults,
// so all pricing comes from the cart configuration (Salesforce) rather than this file.
let STATE_FEE_OVERRIDES = null;
let ENTITY_RENEWAL_PRICE_OVERRIDE = null;
let ENTITY_RENEWAL_LABEL_OVERRIDE = null;

export function setStateFeeOverrides(stateFees) {
    if (!Array.isArray(stateFees) || stateFees.length === 0) {
        STATE_FEE_OVERRIDES = null;
        return;
    }
    const map = {};
    for (const sf of stateFees) {
        const code = sf?.stateCode || sf?.State_Code__c;
        const fee = sf?.fee ?? sf?.Fee__c;
        if (code && Number.isFinite(Number(fee))) {
            map[code] = Number(fee);
        }
    }
    STATE_FEE_OVERRIDES = Object.keys(map).length > 0 ? map : null;
}

export function setEntityRenewalConfig(price, label) {
    ENTITY_RENEWAL_PRICE_OVERRIDE = Number.isFinite(Number(price)) ? Number(price) : null;
    ENTITY_RENEWAL_LABEL_OVERRIDE =
        label && String(label).trim().length > 0 ? String(label) : null;
}

export function getEntityRenewalPrice(fallback = 199) {
    return ENTITY_RENEWAL_PRICE_OVERRIDE != null ? ENTITY_RENEWAL_PRICE_OVERRIDE : fallback;
}

export function getEntityRenewalLabel(fallback = 'Annual renewal') {
    return ENTITY_RENEWAL_LABEL_OVERRIDE != null ? ENTITY_RENEWAL_LABEL_OVERRIDE : fallback;
}

export function getStateNameByCode(code, fallback = '') {
    return STATE_REGISTRY[code]?.name || fallback;
}

export function getStateCodeByName(name, fallback = '') {
    return STATE_BY_NAME[name]?.code || fallback;
}

export function getStateFeeByCode(code, fallback = 0) {
    if (!code) {
        return fallback;
    }
    if (STATE_FEE_OVERRIDES && STATE_FEE_OVERRIDES[code] != null) {
        return STATE_FEE_OVERRIDES[code];
    }
    return STATE_REGISTRY[code]?.fee ?? fallback;
}

export function getStateByCode(code) {
    if (!code || !STATE_REGISTRY[code]) {
        return null;
    }
    return {
        code,
        ...STATE_REGISTRY[code],
        fee: getStateFeeByCode(code, STATE_REGISTRY[code].fee)
    };
}

export function getStateByName(name) {
    if (!name || !STATE_BY_NAME[name]) {
        return null;
    }
    return STATE_BY_NAME[name];
}

export const TERMS_AND_CONDITIONS = 'https://primecorporateservices.com/terms-and-conditions?_gl=1*1cmhtmk*_gcl_au*MTY5MDE5NTg5MC4xNzc1NzI2OTc3';
export const PRIVACY_POLICY = 'https://primecorporateservices.com/privacy-policy/?_gl=1*1cmhtmk*_gcl_au*MTY5MDE5NTg5MC4xNzc1NzI2OTc3';

export const ONLINE_CART_FORM_PAYLOAD = {
    sections: [
        {
            id: 'business',
            label: 'Your Business',
            screens: [
                {
                    id: 'business_name',
                    title: "What's the name of your business?",
                    description: 'Choose a name for your new LLC. This is the first step to making it official.',
                    fields: [
                        {
                            id: 'businessName',
                            type: 'text',
                            label: 'Business Name',
                            placeholder: 'e.g., Acme Consulting',
                            suffix: 'LLC',
                            required: true,
                            minLength: 2,
                            note: 'Removed ‘LLC’ — we’ll add it automatically.',
                        },
                    ],
                    warning: {
                        title: "Don't worry",
                        text: "we'll check name availability in your state. You can always change this later before filing.",
                    },
                },
                {
                    id: 'state_of_formation',
                    title: 'Where will {{businessName}} be located?',
                    description: "Select the state where you'll form your LLC. This determines your state filing fee.",
                    fields: [
                        {
                            id: 'stateOfFormation',
                            type: 'select',
                            label: 'State of Formation',
                            placeholder: 'Select your state...',
                            required: true,
                            options: STATE_OPTIONS,
                        },
                        {
                            id: 'dateOfBirth',
                            type: 'dateOfBirth',
                            label: 'Date of Birth',
                            requiredWhenStateCodes: Object.keys(STATE_DOB_REQUIREMENTS),
                            requirementReasonByStateCode: STATE_DOB_REQUIREMENTS,
                        },
                    ],
                    warning: {
                        variant: 'expandable',
                        preview: 'Most people form their LLC in their home state.',
                        actionText: 'Learn more',
                        details: [
                            'Home State: If you will operate your business primarily in one state, forming in your home state is usually the simplest and most cost-effective option.',
                            'Delaware or Wyoming: These states are popular for asset protection and favorable business laws. However, if you operate in another state, you may need to register there too (foreign qualification), which means additional fees and paperwork.',
                            "Our recommendation: For most small businesses, forming in your home state is the best choice. It's simpler, cheaper, and avoids dual-state obligations.",
                        ],
                    },
                },
            ],
        },
        {
            id: 'account',
            label: 'Your Account & Package',
            screens: [
                {
                    id: 'contact_information',
                    title: "{{businessName}}'s contact information",
                    description: "We'll use this to keep you updated on your LLC's progress. This information won't appear on public filings without your permission.",
                    fields: [
                        {
                            id: 'firstName',
                            type: 'text',
                            label: 'First Name',
                            placeholder: 'John',
                            required: true,
                            columnSpanSm: 6,
                        },
                        {
                            id: 'lastName',
                            type: 'text',
                            label: 'Last Name',
                            placeholder: 'Smith',
                            required: true,
                            columnSpanSm: 6,
                        },
                        {
                            id: 'phoneNumber',
                            type: 'phone',
                            label: 'Phone Number',
                            placeholder: '+1    (555) 123-4567',
                            required: true,
                        },
                        {
                            id: 'contactEmail',
                            type: 'email',
                            label: 'Email Address',
                            placeholder: 'john@example.com',
                            required: true,
                        },
                        {
                            id: 'consentMarketing',
                            size: 'compact',
                            type: 'checkbox',
                            required: false,
                            helperText: '',
                            requiredMessage: '',
                            label: 'I would like to receive exclusive deals, business tips, and promotional offers from PRIME via calls, text messages (SMS/MMS), and email, which may be sent using an automatic telephone dialing system, prerecorded or artificial voice, or AI-generated content. Message frequency varies. You can unsubscribe at any time.',
                        },
                        {
                            id: 'consentOrderUpdates',
                            type: 'checkbox',
                            size: 'compact',
                            required: true,
                            helperText: 'Required so we can send you important updates about your LLC filing.',
                            requiredMessage: `We need your permission to send filing updates and order communications. Without this, we can't keep you informed about your LLC formation.`,
                            label: 'I agree to receive calls, text messages (SMS/MMS), and emails from PRIME regarding my order, LLC filing status, and account updates at the phone number and email address I provided. I understand that calls and messages may be sent using an automatic telephone dialing system, prerecorded or artificial voice, or AI-generated content. Message frequency varies.',
                        },
                    ],
                    sharedDisclosure: {
                        text: 'Consent is not a condition of purchase. Msg & data rates may apply. Reply STOP to cancel texts at any time. View our ',
                        links: [
                            {
                                label: 'Privacy Policy',
                                href: PRIVACY_POLICY,
                            },
                            {
                                label: 'Terms of Service',
                                href: TERMS_AND_CONDITIONS,
                            },
                        ],
                        suffix: '.',
                    },
                },
                {
                    id: 'mailing_address',
                    title: `{{businessName}}'s mailing address`,
                    description: "This is where we'll send important documents and correspondence related to your LLC.",
                    fields: [
                        {
                            id: 'mailingAddress1',
                            type: 'text',
                            label: 'Street Address',
                            placeholder: '123 Main St',
                            required: true,
                            size: 'compact',
                        },
                        {
                            id: 'mailingAddress2',
                            type: 'text',
                            label: 'Apt, Suite, Unit',
                            optional: true,
                            placeholder: 'Apt 4B',
                            required: false,
                            size: 'compact',
                        },
                        {
                            id: 'mailingCity',
                            type: 'text',
                            label: 'City',
                            placeholder: 'New York',
                            required: true,
                            columnSpanSm: 6,
                            size: 'compact',
                        },
                        {
                            id: 'mailingZip',
                            type: 'text',
                            label: 'ZIP Code',
                            placeholder: '10001',
                            required: true,
                            columnSpanSm: 6,
                            size: 'compact',
                            format: 'zip5',
                            validation: 'zip5',
                            validationMessage: 'Enter a valid 5-digit ZIP',
                        },
                        {
                            id: 'mailingState',
                            type: 'selectBasic',
                            label: 'State',
                            placeholder: 'Select state...',
                            required: true,
                            size: 'compact',
                            options: STATE_OPTIONS_BY_NAME,
                        },
                    ],
                },
                {
                    id: 'registered_agent',
                    heroIcon: 'shield',
                    title: 'Protect your privacy with a Registered Agent',
                    description:
                        'Every LLC is legally required to have a Registered Agent - someone available during business hours to receive legal documents and official state correspondence on behalf of your business. Without one, you could miss critical legal notices.',
                    fields: [
                        {
                            id: 'registeredAgent',
                            type: 'choiceCards',
                            required: true,
                            requiredMessage: 'Please select one option to continue.',
                            ctaLabel: 'Why do I need this?',
                            options: [
                                {
                                    value: 'add_registered_agent',
                                    title: 'Add Registered Agent',
                                    subtitle: 'Privacy protection + compliance monitoring',
                                    priceLabel: '$99/yr',
                                    recommended: true,
                                },
                                {
                                    value: 'self_handle',
                                    title: "I'll handle this myself",
                                    subtitle: 'Registered Agent appointed separately (additional cost may apply)',
                                    priceLabel: '',
                                    priceColor: 'success',
                                },
                            ],
                            benefits: [
                                {
                                    icon: 'lock',
                                    text: "Your Registered Agent's address appears on public filings instead of your home address, protecting your privacy.",
                                },
                                {
                                    icon: 'bell',
                                    text: 'We ensure you never miss important legal or tax documents.',
                                },
                                {
                                    icon: 'checklist',
                                    text: 'PRIME monitors compliance deadlines on your behalf.',
                                },
                            ],
                        },
                    ],
                },
                {
                    id: 'expedited_processing',
                    heroIcon: 'zap',
                    title: 'Get to the front of the line',
                    description: 'With Expedited Processing, PRIME will prepare and submit your LLC formation documents to the state within 1 business day of your order.',
                    fields: [
                        {
                            id: 'expeditedProcessing',
                            type: 'choiceCards',
                            required: true,
                            requiredMessage: 'Please select one option to continue.',
                            options: [
                                {
                                    value: 'expedited',
                                    title: 'Expedited Processing',
                                    subtitle: 'Submitted within 1 business day',
                                    priceLabel: '$49',
                                    recommended: true,
                                    leadingIcon: 'zap',
                                },
                                {
                                    value: 'standard',
                                    title: 'Standard Processing',
                                    subtitle: 'Submitted in up to 7 business days',
                                    priceLabel: 'Free',
                                    priceColor: '',
                                    leadingIcon: 'clock',
                                },
                            ],
                            note: {
                                icon: 'info',
                                title: 'Note:',
                                text: 'Expedited Processing means we submit your paperwork within 1 business day. Actual approval time varies by state.',
                            },
                        },
                    ],
                },
                {
                    id: 'relay_bank',
                    heroLogo: 'relay',
                    heroLogoUrl: 'https://media.base44.com/images/public/user_69b781b8d21f98b606ac32a6/4c7ae180b_RelayLogo.png',
                    title: 'Separate your business and personal finances from day one',
                    description: "PRIME has partnered with Relay to make it easy to open a free business bank account. We'll submit an application on your behalf once your LLC is officially formed.",
                    benefits: [
                        {
                            icon: 'wallet',
                            text: 'Free business checking - no monthly fees or minimums',
                        },
                        {
                            icon: 'card',
                            text: 'Get a business debit card for your LLC',
                        },
                        {
                            icon: 'trend',
                            text: 'Easily track business expenses separately from personal spending',
                        },
                    ],
                    benefitsMode: 'always',
                    fields: [
                        {
                            id: 'relayBank',
                            type: 'choiceCards',
                            required: true,
                            requiredMessage: 'Please choose one option to continue.',
                            options: [
                                {
                                    value: 'relay_yes',
                                    title: 'Yes, open a Relay account for me',
                                    subtitle: 'Free business checking - no fees or minimums',
                                    priceLabel: 'Free',
                                    priceColor: 'success',
                                    recommended: true,
                                },
                                {
                                    value: 'relay_no',
                                    title: 'No thanks',
                                    subtitle: "I'll handle my own banking",
                                },
                            ],
                            optInDetails: {
                                showForValue: 'relay_yes',
                                title: 'Relay needs a few details to get your application started',
                                dobLabel: 'Date of Birth',
                                dobHelperText: 'Required by Relay to verify your identity and open your business bank account.',
                                employeeLabel: 'How many employees does your business have?',
                                employeeHelperText: 'Relay uses this to set up the right account type for your business.',
                                employeeOptions: ['Just me (no employees)', '2-5 employees', '6-20 employees', '21-50 employees', '51-100 employees', '100+ employees'],
                            },
                            disclosure:
                                'By opting in, you authorize PRIME to share your formation details with Relay Financial, Inc. to pre-fill your bank account application. Relay will contact you via email to complete the application once your LLC is approved. Banking services provided by Relay Financial, Inc. Member FDIC through partner banks.',
                        },
                    ],
                },
            ],
        },
        {
            id: 'review',
            label: 'Review & Checkout',
            screens: [
                {
                    id: 'ssn_collection',
                    title: 'Identity verification',
                    description: 'Provide your SSN/ITIN to continue to checkout and complete your filing.',
                    fields: [],
                },
                {
                    id: 'terms_conditions',
                    title: 'Review our Terms & Conditions',
                    description: 'Please review and accept our terms to continue with your order.',
                    fields: [
                        {
                            id: 'termsAccepted',
                            type: 'termsAcceptance',
                            required: true,
                            requiredMessage: 'Please accept Terms & Conditions to continue.',
                        },
                    ],
                },
                {
                    id: 'backup_business_name',
                    title: 'What backup business name would you like to use?',
                    description: ``,
                    fields: [
                        {
                            id: 'backupBusinessName',
                            type: 'text',
                            label: 'Backup Business Name',
                            placeholder: 'e.g., Acme Consulting',
                            suffix: 'LLC',
                            required: true,
                            minLength: 2,
                            note: 'Removed ‘LLC’ — we’ll add it automatically.',
                        },
                    ],
                    warning: {
                        variant: 'note',
                        icon: 'info',
                        title: 'Note:',
                        text: `We will only use this if your first choice isn't available in your filing state.`,
                    },
                },
                {
                    id: 'order_summary',
                    title: 'Review your order',
                    description: 'ABC LLC is almost official!',
                    fields: [
                        {
                            id: 'orderSummary',
                            type: 'orderSummary',
                            required: true,
                            requiredMessage: 'Please complete payment details to continue.',
                        },
                    ],
                },
            ],
        },
    ],
    response: {
        answers: {
            // expeditedProcessing: 'expedited'
        },
        progress: {
            currentStep: 1,
        },
    },
};
